module.exports = __webpack_public_path__ + "img/F5.09b6964e.svg";